$(document).ready(function () {
    // live-icon
    function setLiveIcon() {

        if($('.live-icon').length === 0){ //如果页面上没有要设置的产品则取消
            return;
        }

        function getLiveProduct() {
            getJson(solution_host + '/api/project/getLiveProduct', {}, function (res) {
                if (res.errCode === 0) {
                    setIcon(res.data);
                    setCache(res.data);
                } else {
                    // common.dd('获取直播产品失败', res)
                }
            });
        }

        function setIcon(liveArr) {
            for (var i = 0; i < liveArr.length; i++) {
                var liveItem = liveArr[i];
                var liveIconDom = $('.live-icon-' + liveItem.productId + ' .live-icon');
                var liveIconHrefDom = $('.live-icon-' + liveItem.productId + ' .live-icon a');
                liveIconDom.css('display', 'inline-block');
                // liveIconHrefDom.attr('href', liveItem.linkUrl);
                liveIconHrefDom.unbind('click');
                liveIconHrefDom.click(function () {
                    window.open(solution_host +liveItem.linkUrl);
                    return false;
                })
                $('.explain-icon-' + liveItem.productId).hide();
            }

        }

        // 设置缓存
        function setCache(val) {
            window.liveIconCache = val;
            // var cacheObj = JSON.stringify(val);
            // sessionStorage.setItem("live-product-ids", cacheObj);
        }

        // 读取缓存
        function readCache() {
            return window.liveIconCache || false;
            // return JSON.parse(sessionStorage.getItem("live-product-ids")) || false
        }

        var liveIconCache = readCache();
        // liveIconCache = false; //不使用缓存
        if (liveIconCache) {
            setIcon(liveIconCache);
        } else {
            getLiveProduct();
        }
    }

    setLiveIcon();

    // 测试用
    if (common.getUrlPara('liveicontest')) {
        $('.live-icon').css('display', 'inline-block');
        $('.explain-icon-box').hide();
    }
    window.setLiveIcon = setLiveIcon;

});
